/* ============================================================================
 * Pitstop Pro - ZIP Warehouse Finder for Globo Product Options
 * ----------------------------------------------------------------------------
 * Drives the Globo "Warehouse Locations" field from a ZIP box; drives Delivery;
 * gates the quick buttons until the form is complete; and keeps a "back to your
 * lift" bar so a cross-brand click is never a lost sale.
 *
 * NOTE ON INSTALL: load this on ALL pages (theme.liquid), not just product
 * pages, so the sticky "back to your lift" bar works on the collection they get
 * sent to. The finder itself still only activates on product pages.
 * ==========================================================================*/
(function () {
  'use strict';

  var CFG = {
    STOCKIST_TAG: 'map_r325w4wq',
    RADIUS_MILES: 300,
    EXPAND_MILES: 500,
    MORE_MILES: 400,   // "Show more" reveals same-brand pickups out to this distance (the nearest 2 always show regardless)
    GLOBO_FIELD_NAME: 'warehouse',   // matches any brand's pickup field: "Warehouse Locations", "Triumph Warehouse", "AMGO Warehouses", etc.
    DELIVERY_FIELD_NAME: 'Delivery Options',
    PICKUP_VALUE: 'Pick Up at Warehouse',
    PICKUP_RE: /pick\s*-?\s*up/i,     // matches the pickup option across brands ("Pick Up at Warehouse", "Free Warehouse Pickup")
    HIDE_NATIVE_LIST: true,
    SHOW_CLOSER_OTHER_BRAND: true,
    SUGGEST_EXCLUDE_BRANDS: ['Atlas', 'AMGO'],   // never recommend these brands' warehouses as a cross-brand alternative



    SHOW_QUICK_BUTTONS: true,
    GATE_QUICK_BUTTONS: true,
    ADD_LIFT_LABEL: 'Just want the lift? Add to cart',
    ACCESSORIES_LABEL: 'See optional add-ons ↓',
    DELIVERY_LABEL: 'Prefer it shipped? Choose Delivery',
    PICKUP_NOTE_TITLE: 'Checkout will ask for a shipping address',
    PICKUP_NOTE: 'We only ask for it for warranty and parts purposes. Your order will still be a warehouse pickup once placed.',

    // ---- Delivery-mode flow (replaces the big equipment + residential/commercial questions) ----
    DELIVERY_VALUE: 'Delivery',                 // the non-pickup Delivery Options value
    EQUIP_NAME_RE: /equipment/i,                // "Do you have the necessary equipment to unload this item?"
    EQUIP_YES: 'Yes', EQUIP_NO: 'No',
    FREIGHT_VALUE_RE: /freight\s*terminal/i,    // the "Nearest Freight terminal" radio (name varies per product)
    RESCOMM_NAME_RE: /residential|commercial/i, // "Residential or commercial address?"
    RESCOMM_LOCK: 'Residential',                // auto-selected + hidden (flip to 'Commercial' if you prefer)
    DEL_DIRECT_TITLE: 'You have direct delivery selected',
    DEL_DIRECT_BODY: 'Your lift ships directly to your location, so you will need a forklift or similar on site to unload it. No unloading equipment on site?',
    DEL_MORE_LINK: 'See our freight terminal option',
    DEL_FREIGHT_EXPLAIN: 'We route your lift to the nearest freight terminal for you to pick up, usually 30 to 50 miles away. No unloading equipment needed on your end.',
    DEL_FREIGHT_BTN: 'Ship to a freight terminal',
    DEL_KEEP_DIRECT_BTN: 'Keep direct delivery',
    DEL_FREIGHT_TITLE: 'Shipping to your nearest freight terminal',
    DEL_BACK_DIRECT_BTN: 'Back to direct delivery',
    // Brands whose Delivery is a custom freight-QUOTE flow (already built on the product page).
    // The widget never renders its delivery box on these - it only flips the Globo radio so the
    // brand's own quote block reveals itself. Leave this alone unless a brand's delivery changes.
    DELNOTE_EXCLUDE_BRANDS: ['Daytona'],

    // Products that ship with FREE LIFTGATE SERVICE (the truck lowers it to the ground).
    // On these the "you will need a forklift on site / freight terminal" box is simply wrong,
    // so the widget stays out of the way: it answers the native unloading question for the
    // customer and lets the product page's own "includes free liftgate service" line show.
    // Detected from the page itself, so any product set up the same way is handled with no
    // per-SKU list to maintain. Requires the words to go together ("includes free liftgate",
    // "liftgate included") so the PAID "Lift Gate Service" accessory can never trigger it.
    LIFTGATE_INCL_RE: /(?:includ\w*|free|no\s+(?:extra|additional)\s+(?:charge|cost))[^.!?]{0,40}lift\s*-?\s*gate|lift\s*-?\s*gate[^.!?]{0,40}(?:includ\w*|is\s+free|at\s+no\s+(?:extra|additional)\s+(?:charge|cost))/i,

    ATC_SELECTOR: '.product-form--atc-button',
    SCROLL_OFFSET: 90,
    PLACE_ABOVE: 'view full pickup',  // FAQ link text; buttons go above its block (works in both pickup & delivery modes)

    STICKY_RETURN: true,             // "back to your lift" bar after a cross-brand click

    // Widget only runs on the discussed brands' LIFTS. This matches the product's Shopify
    // type (2/4/single-post, scissor, alignment, motorcycle, double-wide, mobile column).
    // Tire changers, wheel balancers, tire combos, adaptors, storage, workbenches, etc.
    // are excluded because their type does not contain "lift" (forklifts excluded too).
    LIFT_TYPE_RE: /lift|2\s*-?\s*post|4\s*-?\s*post|single\s*-?\s*post|scissor|alignment|motorcycle|double\s*-?\s*wide|column/i,
    NON_LIFT_TYPE_RE: /fork/i,

    BRAND_COLLECTIONS: {
      'Katool': 'katool', 'Triumph': 'triumph', 'AMGO': 'amgo',
      'Atlas': 'atlas-automotive', 'Ekko': 'ekko-lifts', 'Tuxedo/Launch/iDEAL': 'tuxedo-distributors',
      'Daytona': 'daytona-lifts'
    },
    BRAND_VENDOR: {
      'Katool': 'KATOOL', 'Triumph': 'Triumph', 'AMGO': 'AMGO',
      'Atlas': 'Atlas', 'Ekko': 'Ekko Lifts', 'Tuxedo/Launch/iDEAL': 'Tuxedo',
      'Daytona': 'Daytona Lifts'
    },
    TYPE_COLLECTIONS: { '4-post': '4-post-car-lift', '2-post': '2-post-car-lift' },
    BRANDTYPE_OVERRIDES: {
      // All brands (incl. Triumph) now route to the main 4-post / 2-post
      // collections filtered by vendor. Add a handle here only if you build a
      // dedicated brand+type page you want used instead of the filtered view.
    }
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clean(v) { return ('' + (v == null ? '' : v)).replace(/\s+/g, ' ').trim(); }
  function esc(v) { return v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) { } }
  function brandKey(str) {
    var s = (str || '').toLowerCase();
    if (s.indexOf('katool') > -1) return 'Katool';
    if (s.indexOf('triumph') > -1) return 'Triumph';
    if (s.indexOf('amgo') > -1) return 'AMGO';
    if (s.indexOf('atlas') > -1) return 'Atlas';
    if (s.indexOf('ekko') > -1) return 'Ekko';
    if (s.indexOf('daytona') > -1) return 'Daytona';
    if (s.indexOf('tuxedo') > -1 || s.indexOf('launch') > -1 || s.indexOf('ideal') > -1) return 'Tuxedo/Launch/iDEAL';
    return null;
  }
  function typeKey(t) { var s = (t || '').toLowerCase(); if (/4[\s-]*post/.test(s)) return '4-post'; if (/2[\s-]*post/.test(s)) return '2-post'; return null; }
  function zipFrom(str) { var all = ('' + str).match(/\d{5}/g); return all && all.length ? all[all.length - 1] : null; }
  function miles(la1, lo1, la2, lo2) {
    var R = 3958.8, k = Math.PI / 180, dLa = (la2 - la1) * k, dLo = (lo2 - lo1) * k;
    var a = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(la1 * k) * Math.cos(la2 * k) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function shortBrand(b) { return (b || '').split('/')[0]; }
  function fullAddr(w) {
    var p = [w.addr, w.addr2, clean(w.city) + (w.state ? ', ' + clean(w.state) : '') + (w.zip ? ' ' + w.zip : '')];
    return p.map(clean).filter(Boolean).join(', ');
  }

  var _wh = null;
  var _isLift = false;   // true only for the discussed brands' lift products (gates the quick buttons)
  var _brand = null;     // current product's brand key (gates the delivery box per brand)
  var _title = '';       // current product's title (liftgate detection fallback)
  var _liftgate = false; // sticky: this product includes free liftgate service
  var _delInfoOpen = false;   // delivery box: is the freight-terminal explainer expanded
  function loadWarehouses() {
    if (_wh) return Promise.resolve(_wh);
    return fetch('https://stockist.co/api/v1/' + CFG.STOCKIST_TAG + '/locations/all.js')
      .then(function (r) { return r.json(); })
      .then(function (list) {
        _wh = list.map(function (l) {
          return {
            addr: clean(l.address_line_1), addr2: clean(l.address_line_2),
            city: clean(l.city), state: clean(l.state), zip: ('' + l.postal_code).slice(0, 5).trim(),
            lat: parseFloat(l.latitude), lng: parseFloat(l.longitude),
            brand: brandKey((l.filters && l.filters[0] && l.filters[0].name) || l.name)
          };
        }).filter(function (w) { return !isNaN(w.lat) && !isNaN(w.lng); });
        return _wh;
      });
  }
  function getProduct() {
    var path = location.pathname.split('?')[0];
    return fetch(path + '.js').then(function (r) { return r.json(); })
      .then(function (p) { return { vendor: p.vendor, type: p.type, title: p.title, image: p.featured_image, brand: brandKey(p.vendor), tkey: typeKey(p.type) }; })
      .catch(function () { return null; });
  }
  function geocode(zip) {
    return fetch('https://api.zippopotam.us/us/' + zip).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) { var p = j.places && j.places[0]; if (!p) throw 0; return { lat: parseFloat(p.latitude), lng: parseFloat(p.longitude) }; });
  }
  function redirectFor(brand, tkey) {
    var ov = CFG.BRANDTYPE_OVERRIDES[brand + '|' + tkey];
    if (ov) return ov;
    if (tkey && CFG.TYPE_COLLECTIONS[tkey] && CFG.BRAND_VENDOR[brand])
      return '/collections/' + CFG.TYPE_COLLECTIONS[tkey] + '?filter.p.vendor=' + encodeURIComponent(CFG.BRAND_VENDOR[brand]);
    var h = CFG.BRAND_COLLECTIONS[brand];
    return h ? '/collections/' + h : '/collections/vehicle-lifts';
  }

  function findGloboField() {
    var radios = $all('input[type="radio"]').filter(function (r) { return new RegExp(CFG.GLOBO_FIELD_NAME, 'i').test(r.name || ''); });
    if (!radios.length) return null;
    return radios[0].closest('.gpo-element') || radios[0].closest('.gpo-group') || radios[0].parentNode;
  }
  function globoRadios(field) { return $all('input[type="radio"]', field).filter(function (r) { return new RegExp(CFG.GLOBO_FIELD_NAME, 'i').test(r.name || ''); }); }
  function enrichRadios(field, warehouses, preferBrand) {
    return globoRadios(field).map(function (radio) {
      var z = zipFrom(radio.value || ''), wh = null;
      if (z) {
        var zm = warehouses.filter(function (w) { return w.zip === z; });
        var _v = (radio.value || '').toLowerCase(); var _hit = function (w) { var n = (w.addr || '').split(' ')[0].toLowerCase(); return !!n && _v.indexOf(n) > -1; }; wh = zm.filter(function (w) { return w.brand === preferBrand && _hit(w); })[0] || zm.filter(function (w) { return w.brand === preferBrand; })[0] || zm[0];  // 2026-10-17: two Katool sites can share a ZIP (Denver, Linden), so match the street number too
      }
      return { radio: radio, wh: wh };
    }).filter(function (r) { return r.wh; });
  }
  function pickRadio(radio) {
    var item = radio.closest('.gpo-ov-item') || radio.parentNode, lbl = item && item.querySelector('label');
    if (lbl) lbl.click();
    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function clearSelection(field) {
    globoRadios(field).forEach(function (r) { if (r.checked) { r.checked = false; r.dispatchEvent(new Event('change', { bubbles: true })); } });
  }
  function selectDelivery() {
    var radios = $all('input[type="radio"]').filter(function (r) { return new RegExp(CFG.DELIVERY_FIELD_NAME, 'i').test(r.name || ''); });
    var del = radios.filter(function (r) { return !CFG.PICKUP_RE.test(r.value || ''); })[0];
    if (!del) return false;
    pickRadio(del);
    return true;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - CFG.SCROLL_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function isPickupSelected() {
    var radios = $all('input[type="radio"]').filter(function (r) { return new RegExp(CFG.DELIVERY_FIELD_NAME, 'i').test(r.name || ''); });
    if (!radios.length) return false;
    var pick = radios.filter(function (r) { return CFG.PICKUP_RE.test(r.value || ''); })[0];
    return !!(pick && pick.checked);
  }
  function isDeliverySelected() {
    var radios = $all('input[type="radio"]').filter(function (r) { return new RegExp(CFG.DELIVERY_FIELD_NAME, 'i').test(r.name || ''); });
    if (!radios.length) return false;
    var del = radios.filter(function (r) { return !CFG.PICKUP_RE.test(r.value || ''); })[0];
    return !!(del && del.checked);
  }
  // ---- delivery sub-field drivers (equipment / freight terminal / residential-commercial) ----
  function radiosByName(re) { return $all('input[type="radio"]').filter(function (r) { return re.test(r.name || ''); }); }
  function radioByValue(re) { return $all('input[type="radio"]').filter(function (r) { return re.test(r.value || ''); })[0]; }
  function hideFieldOf(radio) { var el = radio && radio.closest('.gpo-element'); if (el && el.style.display !== 'none') el.style.display = 'none'; }
  function showFieldOf(radio) { var el = radio && radio.closest('.gpo-element'); if (el && el.style.display === 'none') el.style.display = ''; }
  function equipmentValue() { var r = radiosByName(CFG.EQUIP_NAME_RE).filter(function (x) { return x.checked; })[0]; return r ? clean(r.value) : null; }
  function setRadioByPredicate(list, ok) { var r = list.filter(ok)[0]; if (r && !r.checked) pickRadio(r); return !!r; }
  function setEquipment(val) { return setRadioByPredicate(radiosByName(CFG.EQUIP_NAME_RE), function (x) { return clean(x.value).toLowerCase() === val.toLowerCase(); }); }
  function setFreight() { var r = radioByValue(CFG.FREIGHT_VALUE_RE); if (r && !r.checked) pickRadio(r); return !!r; }
  function setResComm() { return setRadioByPredicate(radiosByName(CFG.RESCOMM_NAME_RE), function (x) { return clean(x.value).toLowerCase() === CFG.RESCOMM_LOCK.toLowerCase(); }); }
  // true when a radio's option row shows a surcharge, e.g. "Lift Gate Service (+$130.00 USD)".
  // The widget never auto-selects a paid option on the customer's behalf.
  function radioCosts(r) { var it = r && (r.closest('.gpo-ov-item') || r.parentNode); return /\+\s*\$\s*[\d.,]+/.test((it && (it.innerText || it.textContent)) || ''); }
  // Does this product include free liftgate service? Read from the product page's own Globo
  // content blocks (text-only elements, so the paid accessory option can never match), with
  // the product title as a fallback. Sticky once true: Globo re-renders and hides blocks, but
  // the text stays in the DOM, and a product does not stop including liftgate mid-session.
  function liftgateIncluded() {
    if (_liftgate) return true;
    var blocks = $all('.gpo-element').filter(function (e) { return !e.querySelector('input,select,textarea'); });
    var hit = blocks.some(function (e) { return CFG.LIFTGATE_INCL_RE.test(clean(e.textContent)); });
    _liftgate = hit || CFG.LIFTGATE_INCL_RE.test(clean(_title));
    return _liftgate;
  }
  // Only the discussed brands' LIFTS get the widget (not tire combos, changers, balancers, storage, etc.)
  function isDiscussedLift(product) {
    if (!product || !product.brand) return false;              // one of the 6 discussed brands
    var t = product.type || '';
    return CFG.LIFT_TYPE_RE.test(t) && !CFG.NON_LIFT_TYPE_RE.test(t);
  }
  function deliveryField() {
    var r = $all('input[type="radio"]').filter(function (x) { return new RegExp(CFG.DELIVERY_FIELD_NAME, 'i').test(x.name || ''); })[0];
    return r ? (r.closest('.gpo-element') || r.closest('.gpo-group')) : null;
  }
  // after switching to Delivery, bring the Delivery Options field to the top so the
  // customer sees it's set to Delivery, with the follow-up questions flowing below it.
  function afterDeliveryScroll() {
    setTimeout(function () { scrollToEl(deliveryField() || $('.psw-quick') || $(CFG.ATC_SELECTOR)); }, 320);
  }
  function allRequiredMet() {
    var reqEls = $all('.gpo-element').filter(function (el) { return el.querySelector('.gpo-label.required') && el.offsetParent !== null; });
    return reqEls.every(function (el) {
      var radios = $all('input[type="radio"]', el);
      if (radios.length) return radios.some(function (r) { return r.checked; });
      var inp = el.querySelector('input[type="text"],input[type="number"],input[type="email"],input[type="tel"],select,textarea');
      if (inp) return !!clean(inp.value);
      return true;
    });
  }
  function updateQuickVisibility() {
    var row = $('.psw-quick'); if (!row) return;
    row.style.display = (!CFG.GATE_QUICK_BUTTONS || allRequiredMet()) ? 'flex' : 'none';
  }

  var CSS = '' +
    '.psw-wrap{margin:0 0 14px;font-family:inherit}' +
    '.psw-row{display:flex;gap:8px;align-items:stretch}' +
    '.psw-in{flex:1;min-width:0;padding:11px 12px;border:1px solid #c7ccd1;border-radius:8px;font-size:15px}' +
    '.psw-in:focus{outline:none;border-color:#111;box-shadow:0 0 0 2px rgba(0,0,0,.08)}' +
    '.psw-btn{padding:11px 18px;border:0;border-radius:8px;background:#111;color:#fff;font-weight:700;font-size:14px;cursor:pointer;white-space:nowrap}' +
    '.psw-btn:disabled{opacity:.5}' +
    '.psw-out{margin-top:10px;font-size:14px;line-height:1.5}' +
    '.psw-opt{display:block;margin-top:6px;padding:10px 12px;border:1px solid #d8dde1;border-radius:8px;background:#fff;cursor:pointer;font-size:13px}' +
    '.psw-opt:hover{border-color:#111}' +
    '.psw-opt.psw-sel{border:1px solid #16a34a;border-left:4px solid #16a34a;background:#f6fbf7}' +
    '.psw-opt.psw-sel::before{content:"\\2713 ";color:#16a34a;font-weight:700}' +
    '.psw-note{margin-top:8px;padding:10px 12px;border:1px solid #cfe0f3;border-left:4px solid #2b6cb0;border-radius:8px;background:#f5f9ff;font-size:13px}' +
    '.psw-warn{padding:12px;border:1px solid #f0d58a;border-left:4px solid #d99e00;border-radius:8px;background:#fffdf5}' +
    '.psw-cta{display:inline-block;margin-top:9px;margin-right:8px;padding:10px 16px;background:#111;color:#fff !important;text-decoration:none;border-radius:8px;font-weight:700;font-size:14px;cursor:pointer;border:0}' +
    '.psw-ghost{background:#fff;color:#111 !important;border:1px solid #111}' +
    '.psw-full{display:block;width:100%;box-sizing:border-box;text-align:center;margin:8px 0 0 !important}' +
    '.psw-muted{color:#667;font-size:12.5px;margin-top:6px}' +
    '.psw-err{color:#b42318;font-size:13px;margin-top:8px}' +
    '.psw-quick{display:flex;gap:8px;margin:14px 0;width:100%;box-sizing:border-box}' +
    '.psw-qbtn{flex:1 1 0;min-width:0;padding:13px 14px;border:1.5px solid #111;border-radius:8px;background:#fff;color:#111;font-weight:700;font-size:14px;cursor:pointer;text-align:center;box-sizing:border-box}' +
    '.psw-qbtn:hover{background:#f3f3f3}' +
    '.psw-qprimary{background:#00a1cf;color:#fff;border-color:#00a1cf}.psw-qprimary:hover{background:#008fb8;border-color:#008fb8}' +
    '.psw-pickup-note{width:100%;box-sizing:border-box;margin:0 0 10px;padding:9px 12px;border:1px solid #e0a19a;border-left:4px solid #d9776b;border-radius:7px;background:#fdf2f0;color:#4a1712;font-size:12.5px;line-height:1.4}' +
    '.psw-pickup-note .psw-pn-title{display:flex;gap:7px;align-items:center;font-weight:700;font-size:13.5px;margin-bottom:2px;color:#b23b30}' +
    '.psw-pickup-note .psw-pn-ico{flex:0 0 auto;font-size:14px;line-height:1}' +
    '.psw-delnote{width:100%;box-sizing:border-box;margin:0 0 10px;padding:11px 13px;border:1px solid #e0a19a;border-left:4px solid #d9776b;border-radius:7px;background:#fdf2f0;color:#4a1712;font-size:12.5px;line-height:1.45}' +
    '.psw-delnote .psw-pn-title{display:flex;gap:7px;align-items:center;font-weight:700;font-size:13.5px;margin-bottom:3px;color:#b23b30}' +
    '.psw-delnote .psw-pn-ico{flex:0 0 auto;font-size:14px;line-height:1}' +
    '.psw-delnote .psw-dl-link{color:#a11810;font-weight:700;text-decoration:underline;cursor:pointer;white-space:nowrap}' +
    '.psw-delnote .psw-dl-panel{margin-top:9px;padding-top:9px;border-top:1px dashed #e2aaa2}' +
    '.psw-delnote .psw-dl-actions{display:flex;gap:8px;margin-top:9px;flex-wrap:wrap}' +
    '.psw-delnote .psw-dl-btn{padding:9px 13px;border-radius:7px;font-weight:700;font-size:12.5px;cursor:pointer;border:1px solid #c98c85;background:#fff;color:#8a2f26}' +
    '.psw-delnote .psw-dl-btn:hover{background:#faeae7}' +
    '.psw-delnote .psw-dl-btn.primary{background:#00a1cf;border-color:#00a1cf;color:#fff}' +
    '.psw-delnote .psw-dl-btn.primary:hover{background:#008fb8}' +
    '.psw-managed .messages{display:none !important}' +
    '.psw-sticky{position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#0f172a;color:#fff;display:flex;align-items:center;justify-content:center;padding:12px 16px;font-family:inherit;box-shadow:0 -6px 24px rgba(0,0,0,.4);border-top:3px solid #00b4e6;animation:pswUp .35s ease}' +
    '@keyframes pswUp{from{transform:translateY(110%)}to{transform:translateY(0)}}' +
    '.psw-sticky-in{display:flex;align-items:center;gap:14px;max-width:1000px;width:100%}' +
    '.psw-sticky img{width:56px;height:56px;object-fit:contain;background:#fff;border-radius:8px;flex:0 0 auto;padding:3px;box-sizing:border-box}' +
    '.psw-sticky-txt{flex:1;min-width:0;line-height:1.3}' +
    '.psw-sticky-txt b{display:block;font-weight:800;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.psw-sticky-txt em{color:#9fb3c8;font-size:12.5px;font-style:normal}' +
    '.psw-sticky-btn{flex:0 0 auto;background:#00b4e6;color:#00131c !important;text-decoration:none;font-weight:800;font-size:14px;padding:12px 20px;border-radius:8px;white-space:nowrap}' +
    '.psw-sticky-btn:hover{background:#25c9ff}' +
    '.psw-sticky-x{flex:0 0 auto;cursor:pointer;font-weight:400;font-size:22px;line-height:1;opacity:.7;color:#fff;padding:2px 4px 2px 2px}' +
    '.psw-sticky-x:hover{opacity:1}' +
    // mobile: chat bubble lives in the bottom-right corner; keep the row clear of it
    '@media (max-width:600px){' +
      '.psw-sticky{padding:9px 12px}' +
      '.psw-sticky-in{gap:9px;padding-right:98px}' +   // clear the ~92px chat bubble corner
      '.psw-sticky img{display:none}' +                // drop thumbnail on mobile to make room for a clear label
      '.psw-sticky-txt b{font-size:13.5px}' +
      '.psw-sticky-txt em{display:none}' +
      '.psw-sticky-btn{padding:9px 12px;font-size:12.5px}' +
      '.psw-sticky-x{font-size:24px;padding:2px 0 2px 4px}' +
    '}';
  function injectCSS() { if ($('#psw-style')) return; var s = document.createElement('style'); s.id = 'psw-style'; s.textContent = CSS; document.head.appendChild(s); }

  // "back to your lift" bar - shows on any page the customer lands on after a cross-brand click
  function initStickyReturn() {
    if (!CFG.STICKY_RETURN) return;
    var raw = ssGet('psw_return'); if (!raw) return;
    var data; try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || !data.url) return;
    if (location.pathname === data.url) { ssDel('psw_return'); return; }   // they're back
    if ($('.psw-sticky')) return;
    var img = data.image ? (data.image.indexOf('//') === 0 ? 'https:' + data.image : data.image) : '';
    var bar = document.createElement('div');
    bar.className = 'psw-sticky';
    bar.innerHTML = '<div class="psw-sticky-in">' +
      (img ? '<img src="' + img + '" alt="">' : '') +
      '<div class="psw-sticky-txt"><b>' + (data.title || 'Your lift') + '</b><em>Still deciding? Jump back to the lift you were viewing.</em></div>' +
      '<a class="psw-sticky-btn" href="' + data.url + '">&larr; Jump back to your lift</a>' +
      '<span class="psw-sticky-x" title="dismiss">&times;</span>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('.psw-sticky-x').addEventListener('click', function () { ssDel('psw_return'); bar.remove(); });
  }

  function findAccGroup() {
    // heading text varies per product: "Optional Accessories", "Option Accessories", etc.
    var accLabel = $all('.gpo-label').filter(function (l) { return /option(?:al)?\s+accessories/i.test(l.innerText || ''); })[0];
    return { label: accLabel, group: accLabel ? (accLabel.closest('.gpo-element') || accLabel.closest('.gpo-group')) : null };
  }
  function findPlaceAnchor() {
    // anchor above the visible info/FAQ block. Pickup shows "proper equipment to haul...",
    // delivery shows "You can always confirm availability..."; both carry the FAQ link.
    var infoPat = /view full pickup|proper equipment to haul|confirm availability ahead|inventory status before/i;
    var ge = $all('.gpo-element').filter(function (e) { return e.offsetParent !== null && infoPat.test(e.innerText || ''); })[0];
    if (ge) return ge;
    var link = $all('a').filter(function (a) { return a.offsetParent !== null && /view full pickup/i.test(a.innerText || ''); })[0];
    if (link) return link.closest('.gpo-element') || link.closest('.gpo-form__group') || link.parentElement;
    return findAccGroup().group || null;
  }
  // Idempotent: builds the quick-button row, and rebuilds/repositions it if the
  // accessories section renders late or the theme re-renders the form (e.g. after add-to-cart).
  function ensureQuickButtons() {
    // "Just want the lift? Add to cart" + "See add-ons" are LIFT-only
    if (!CFG.SHOW_QUICK_BUTTONS || !_isLift) { var ex0 = $('.psw-quick'); if (ex0) ex0.remove(); return; }
    var atc = $(CFG.ATC_SELECTOR);
    if (!atc) return;
    var acc = findAccGroup();
    var existing = $('.psw-quick');
    // no accessories on this product -> no quick buttons at all (nothing to skip past)
    if (!acc.group) { if (existing) existing.remove(); return; }
    var anchor = findPlaceAnchor();
    var placedRight = !anchor || (existing && existing.nextElementSibling === anchor);
    // already correct: has the accessories button and sits just above the FAQ block
    if (existing && document.body.contains(existing) && $('.psw-acc', existing) && placedRight) return;
    if (existing) existing.remove();

    var row = document.createElement('div'); row.className = 'psw-quick';
    var addBtn = document.createElement('button'); addBtn.type = 'button'; addBtn.className = 'psw-qbtn psw-qprimary'; addBtn.textContent = CFG.ADD_LIFT_LABEL;
    addBtn.addEventListener('click', function () { atc.click(); });
    row.appendChild(addBtn);
    if (acc.label) {
      var accBtn = document.createElement('button'); accBtn.type = 'button'; accBtn.className = 'psw-qbtn psw-acc'; accBtn.textContent = CFG.ACCESSORIES_LABEL;
      accBtn.addEventListener('click', function () {
        var t = findAccGroup().label || acc.label;
        var y = t.getBoundingClientRect().top + window.pageYOffset - CFG.SCROLL_OFFSET;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      row.appendChild(accBtn);
    }
    var whField = findGloboField();
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(row, anchor);           // just above the pickup/FAQ block
    else if (acc.group && acc.group.parentNode) acc.group.parentNode.insertBefore(row, acc.group);
    else if (whField && whField.parentNode) whField.parentNode.insertBefore(row, whField.nextSibling);
    else if (atc.parentNode) atc.parentNode.insertBefore(row, atc);
    updateQuickVisibility();
  }
  // Pickup-only heads-up that checkout still asks for a shipping address (warranty/parts).
  // Sits directly above the quick buttons (or the FAQ block / ATC if there are none).
  function ensurePickupNote() {
    var existing = $('.psw-pickup-note');
    var show = isPickupSelected();   // any warehouse-pickup product (lift or not)
    if (!show) { if (existing) existing.remove(); return; }
    var atc = $(CFG.ATC_SELECTOR); if (!atc) return;
    var anchor = $('.psw-quick') || findPlaceAnchor() || atc;
    if (!anchor || !anchor.parentNode) return;
    if (existing) {
      if (existing.nextElementSibling === anchor) return;   // already correctly placed
      existing.remove();
    }
    var note = document.createElement('div');
    note.className = 'psw-pickup-note';
    note.innerHTML = '<span class="psw-pn-title"><span class="psw-pn-ico">⚠️</span><span>' + CFG.PICKUP_NOTE_TITLE + '</span></span>' + CFG.PICKUP_NOTE;
    anchor.parentNode.insertBefore(note, anchor);
  }

  // Delivery-mode box: replaces the native equipment + residential/commercial questions.
  // Drives the Globo fields behind the scenes (direct delivery = equipment Yes + res/comm;
  // freight terminal = equipment No + Nearest Freight terminal).
  function ensureDeliveryNote() {
    var boxes = $all('.psw-delnote');
    // lift-only (tire changers / balancers keep their own native lift-gate option), and never on
    // freight-quote brands like Daytona - their own quote block owns the delivery experience.
    var quoteBrand = _brand && CFG.DELNOTE_EXCLUDE_BRANDS.indexOf(_brand) !== -1;
    if (!isDeliverySelected() || !_isLift || quoteBrand) { boxes.forEach(function (b) { b.remove(); }); return; }

    // ---- FREE LIFTGATE PRODUCTS (e.g. Triumph NSS8X-1) ----------------------------------
    // The carrier lowers the lift to the ground, so "you will need a forklift on site" and the
    // freight-terminal workaround are both wrong here. Show no box at all: answer the native
    // unloading question as No (the no-equipment path, which is what reveals the product's own
    // "includes free liftgate service" line) and keep the raw question hidden so nobody reads a
    // forklift requirement that does not apply. If the No option carries a surcharge on some
    // product, nothing is auto-selected and the native question is left visible for the
    // customer to answer - the widget never silently adds a paid option.
    if (liftgateIncluded()) {
      boxes.forEach(function (b) { b.remove(); });
      var eqRadios = radiosByName(CFG.EQUIP_NAME_RE);
      var eqNo = eqRadios.filter(function (x) { return clean(x.value).toLowerCase() === CFG.EQUIP_NO.toLowerCase() && !radioCosts(x); })[0];
      if (eqNo) {
        if (!eqNo.checked) pickRadio(eqNo);
        eqRadios.forEach(hideFieldOf);
        radiosByName(CFG.RESCOMM_NAME_RE).forEach(hideFieldOf);
        setResComm();
      } else {
        eqRadios.forEach(showFieldOf);   // let the customer answer it themselves
      }
      updateQuickVisibility();
      return;
    }
    // -------------------------------------------------------------------------------------

    if (boxes.length > 1) { boxes.forEach(function (b) { b.remove(); }); boxes = []; }   // dup-proof
    var existing = boxes[0];
    // hide the native sub-questions; the box drives them
    radiosByName(CFG.EQUIP_NAME_RE).forEach(hideFieldOf);
    var fr = radioByValue(CFG.FREIGHT_VALUE_RE); if (fr) hideFieldOf(fr);
    radiosByName(CFG.RESCOMM_NAME_RE).forEach(hideFieldOf);
    // default to direct delivery if the customer has not chosen a path yet
    var ev = equipmentValue();
    if (ev == null) { setEquipment(CFG.EQUIP_YES); ev = CFG.EQUIP_YES; }
    var freight = new RegExp('^' + CFG.EQUIP_NO + '$', 'i').test(ev);
    if (freight) { setFreight(); } else { setResComm(); }
    updateQuickVisibility();   // keep the add-to-cart / accessories buttons in sync in delivery mode

    var st = (freight ? 'freight' : 'direct') + (_delInfoOpen && !freight ? '-open' : '');
    var df = deliveryField(); if (!df || !df.parentNode) return;   // sit right below the Delivery Options box
    // rebuild only when state or placement changed (avoids flicker from the self-heal loop)
    if (existing && existing.getAttribute('data-st') === st && existing.previousElementSibling === df) return;
    if (existing) existing.remove();

    var box = document.createElement('div');
    box.className = 'psw-delnote'; box.setAttribute('data-st', st);
    var html = '';
    if (freight) {
      html += '<span class="psw-pn-title"><span class="psw-pn-ico">✅</span><span>' + CFG.DEL_FREIGHT_TITLE + '</span></span>';
      html += CFG.DEL_FREIGHT_EXPLAIN;
      html += '<div class="psw-dl-actions"><button type="button" class="psw-dl-btn psw-dl-direct">' + CFG.DEL_BACK_DIRECT_BTN + '</button></div>';
    } else {
      html += '<span class="psw-pn-title"><span class="psw-pn-ico">✅</span><span>' + CFG.DEL_DIRECT_TITLE + '</span></span>';
      html += CFG.DEL_DIRECT_BODY + ' <span class="psw-dl-link psw-dl-more">' + CFG.DEL_MORE_LINK + ' &rsaquo;</span>';
      if (_delInfoOpen) {
        html += '<div class="psw-dl-panel"><b>Freight terminal delivery:</b> ' + CFG.DEL_FREIGHT_EXPLAIN +
          '<div class="psw-dl-actions">' +
          '<button type="button" class="psw-dl-btn primary psw-dl-freight">' + CFG.DEL_FREIGHT_BTN + '</button>' +
          '<button type="button" class="psw-dl-btn psw-dl-less">' + CFG.DEL_KEEP_DIRECT_BTN + '</button>' +
          '</div></div>';
      }
    }
    box.innerHTML = html;
    df.parentNode.insertBefore(box, df.nextSibling);
    var m = $('.psw-dl-more', box); if (m) m.addEventListener('click', function () { _delInfoOpen = true; ensureDeliveryNote(); });
    var l = $('.psw-dl-less', box); if (l) l.addEventListener('click', function () { _delInfoOpen = false; ensureDeliveryNote(); });
    var f = $('.psw-dl-freight', box); if (f) f.addEventListener('click', function () { _delInfoOpen = false; setEquipment(CFG.EQUIP_NO); setFreight(); ensureDeliveryNote(); });
    var d = $('.psw-dl-direct', box); if (d) d.addEventListener('click', function () { setEquipment(CFG.EQUIP_YES); setResComm(); ensureDeliveryNote(); });
  }

  function buildUI(field, product, warehouses) {
    if ($('.psw-wrap', field)) return;
    var candidates = enrichRadios(field, warehouses, product.brand);
    if (!candidates.length) return;

    field.classList.add('psw-managed');
    if (CFG.HIDE_NATIVE_LIST) {
      ['.gpo-dropdown', '.gpo-selected-values'].forEach(function (sel) { var el = $(sel, field); if (el) el.style.display = 'none'; });
    }

    var wrap = document.createElement('div');
    wrap.className = 'psw-wrap';
    wrap.innerHTML =
      '<div class="psw-row"><input class="psw-in" type="text" inputmode="numeric" maxlength="5" ' +
      'placeholder="Enter your ZIP to find the closest pickup" aria-label="Your ZIP code">' +
      '<button type="button" class="psw-btn">Find closest</button></div><div class="psw-out" aria-live="polite"></div>';
    var anchor = $('.gpo-dropdown', field) || $('.gpo-selected-values', field) || field.firstChild;
    field.insertBefore(wrap, anchor);
    var input = $('.psw-in', wrap), btn = $('.psw-btn', wrap), out = $('.psw-out', wrap);

    var DELIVERY_BTN = '<button type="button" class="psw-cta psw-ghost psw-full psw-delivery">' + CFG.DELIVERY_LABEL + '</button>';

    function crossHtml(alt, lead) {
      var url = redirectFor(alt.brand, product.tkey);
      var typeLabel = product.tkey ? product.tkey + ' lifts' : 'lifts';
      return lead + ' <b>' + shortBrand(alt.brand) + '</b> has a warehouse about <b>' + Math.round(alt.dist) +
        ' mi</b> away at <b>' + fullAddr(alt) + '</b>. <a class="psw-cta psw-cross" href="' + url + '">See ' + shortBrand(alt.brand) + ' ' + typeLabel + ' &rarr;</a>';
    }
    function bindCommon() {
      $all('.psw-delivery', out).forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); selectDelivery(); afterDeliveryScroll(); }); });
      var eb = $('.psw-expand', out);
      if (eb) eb.addEventListener('click', function () { out.innerHTML = '<div class="psw-muted">Widening to ' + CFG.EXPAND_MILES + ' mi...</div>'; window.__psw_eval(CFG.EXPAND_MILES, true); });
      // remember where to send them back if they follow a cross-brand link
      $all('.psw-cross', out).forEach(function (el) {
        el.addEventListener('click', function () { ssSet('psw_return', JSON.stringify({ url: location.pathname, title: product.title || document.title, image: product.image || '' })); });
      });
    }

    function evaluate(loc, radius, expanded) {
      window.__psw_eval = function (r, ex) { evaluate(loc, r, ex); };
      loadWarehouses().then(function (all) {
        candidates.forEach(function (c) { c.dist = miles(loc.lat, loc.lng, c.wh.lat, c.wh.lng); });
        candidates.sort(function (a, b) { return a.dist - b.dist; });
        var within = candidates.filter(function (c) { return c.dist <= radius; });

        var others = all.filter(function (w) { return w.brand && w.brand !== product.brand; });
        others.forEach(function (w) { w.dist = miles(loc.lat, loc.lng, w.lat, w.lng); });
        others.sort(function (a, b) { return a.dist - b.dist; });
        var otherWithin = others.filter(function (w) { return w.dist <= radius; });
        // Deprioritize excluded brands (Atlas/AMGO): only suggest them as a cross-brand
        // alternative when no other brand is available nearby. Same-brand (being ON an
        // Atlas/AMGO product) is unaffected - that runs through `within` above.
        var otherPref = otherWithin.filter(function (w) { return CFG.SUGGEST_EXCLUDE_BRANDS.indexOf(w.brand) === -1; });
        var suggest = otherPref[0] || otherWithin[0];

        if (within.length) {
          pickRadio(within[0].radio);
          var html = '<div class="psw-muted">Nearest is selected. Tap any location to switch:</div>';
          within.forEach(function (c, i) {
            html += '<div class="psw-opt' + (i === 0 ? ' psw-sel' : '') + '" data-i="' + i + '"><b>' + fullAddr(c.wh) + '</b> &nbsp;-&nbsp; ' + Math.round(c.dist) + ' mi</div>';
          });
          if (CFG.SHOW_CLOSER_OTHER_BRAND && otherPref[0] && otherPref[0].dist < within[0].dist)
            html += '<div class="psw-note"><b>Closer option:</b> ' + crossHtml(otherPref[0], 'if you would rather pick up sooner,') + '</div>';
          html += DELIVERY_BTN;
          out.innerHTML = html;
          $all('.psw-opt', out).forEach(function (el) {
            el.addEventListener('click', function () {
              var c = within[+el.getAttribute('data-i')];
              if (!c) return;
              pickRadio(c.radio);
              $all('.psw-opt', out).forEach(function (o) { o.classList.remove('psw-sel'); });
              el.classList.add('psw-sel');
            });
          });
          bindCommon();
        } else {
          clearSelection(field);
          var html = '';
          var within400 = candidates.filter(function (c) { return c.dist <= CFG.MORE_MILES; });
          var showN = expanded ? Math.max(2, within400.length) : 2;
          var near = candidates.slice(0, showN);
          if (near.length) {
            // Always surface the closest same-brand pickup(s), even beyond the usual radius,
            // so a customer willing to drive always has at least one option to choose.
            html += '<div class="psw-warn">No <b>' + product.brand + '</b> pickup within ' + radius +
              ' mi of you. Your closest ' + (near.length > 1 ? 'locations are' : 'location is') +
              ' below, and you can still pick up there if you are willing to drive. Tap to select:</div>';
            near.forEach(function (c, i) {
              html += '<div class="psw-opt psw-faropt" data-i="' + i + '"><b>' + fullAddr(c.wh) +
                '</b> &nbsp;-&nbsp; ' + Math.round(c.dist) + ' mi</div>';
            });
            // show-more / collapse toggle - sits under the locations, ABOVE the closer-option box
            if (within400.length > 2) {
              html += expanded
                ? '<button type="button" class="psw-cta psw-ghost psw-full psw-less">Show fewer locations</button>'
                : '<button type="button" class="psw-cta psw-ghost psw-full psw-more">Show more ' + shortBrand(product.brand) + ' locations (' + (within400.length - 2) + ' more)</button>';
            }
          }
          if (suggest && (!candidates[0] || suggest.dist < candidates[0].dist)) {
            html += '<div class="psw-note"><b>Closer option:</b> ' + crossHtml(suggest, 'if you would rather not drive as far,') + '</div>';
          }
          if (!near.length) {
            html += '<div class="psw-warn">We could not find a <b>' + product.brand + '</b> pickup location for this item. Delivery is your best option.</div>';
          }
          html += DELIVERY_BTN;
          out.innerHTML = html;
          var mb = $('.psw-more', out);
          if (mb) mb.addEventListener('click', function () { window.__psw_eval(radius, true); });
          var lb = $('.psw-less', out);
          if (lb) lb.addEventListener('click', function () { window.__psw_eval(radius, false); });
          $all('.psw-faropt', out).forEach(function (el) {
            el.addEventListener('click', function () {
              var c = candidates[+el.getAttribute('data-i')];
              if (!c) return;
              pickRadio(c.radio);
              $all('.psw-faropt', out).forEach(function (o) { o.classList.remove('psw-sel'); });
              el.classList.add('psw-sel');
              updateQuickVisibility();
            });
          });
          bindCommon();
        }
        updateQuickVisibility();
      });
    }

    function run() {
      var zip = (input.value || '').replace(/\D/g, '').slice(0, 5);
      if (zip.length !== 5) { out.innerHTML = '<div class="psw-err">Enter a valid 5-digit ZIP.</div>'; return; }
      btn.disabled = true; out.innerHTML = '<div class="psw-muted">Finding your closest pickup...</div>';
      geocode(zip).then(function (loc) { evaluate(loc, CFG.RADIUS_MILES, false); })
        .catch(function () { out.innerHTML = '<div class="psw-err">Could not look up that ZIP. Double-check it and try again.</div>'; })
        .then(function () { btn.disabled = false; });
    }
    btn.addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
  }

  function boot() {
    injectCSS();
    initStickyReturn();                      // runs on every page
    if (!/\/products\//.test(location.pathname)) return;   // finder only on product pages

    Promise.all([getProduct(), loadWarehouses()]).then(function (res) {
      var product = res[0], warehouses = res[1];
      if (!product || !product.brand) return;   // discussed brands only (the warehouse-pickup brands)
      _isLift = isDiscussedLift(product);        // ZIP finder + note run on all pickup products; quick buttons are lift-only
      _brand = product.brand;                    // gates the delivery box for freight-quote brands
      _title = product.title || document.title;  // liftgate detection fallback

      // quick buttons + pickup / delivery notes (self-healing)
      var jt = setInterval(function () { ensureQuickButtons(); ensurePickupNote(); ensureDeliveryNote(); }, 600);
      setTimeout(function () { clearInterval(jt); }, 30000);
      document.addEventListener('change', function () { updateQuickVisibility(); ensurePickupNote(); ensureDeliveryNote(); }, true);
      new MutationObserver(function () { ensureQuickButtons(); updateQuickVisibility(); ensurePickupNote(); ensureDeliveryNote(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var field = findGloboField();
        if (field) { clearInterval(timer); buildUI(field, product, warehouses); }
        else if (tries > 40) clearInterval(timer);
      }, 500);
      new MutationObserver(function () {
        var field = findGloboField();
        if (field && !$('.psw-wrap', field)) buildUI(field, product, warehouses);
      }).observe(document.body, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();